import React from "react";
import { SELECTED_ELEMENT_COLOR, GRID_CELL_SIZE_M } from "../configuratorConstants";
import { ReactComponent as WindowSvg } from '../../Assets/window.svg'; // Используем тот же window.svg

const PanoramicWindowRenderer = ({
  element,
  scale,
  wallThickness,
  isSelected,
  windowVisualNeedsFlip,
  highlightForBlindsPlacement = false,
  isFrameless = false, // Параметр для определения режима (модульный/безкаркасный)
  segmentId,
  parentWallId,
}) => {
  // Игнорируем реальную ширину панорамного окна из element.width.
  // Используем разные размеры для модульного и безкаркасного режимов
  let standardWindowWidthM;
  let widthMultiplier;
  let yOffsetDivider;
  let xOffsetMultiplier; // Множитель для позиционирования по X
  
  if (isFrameless) {
    standardWindowWidthM = GRID_CELL_SIZE_M * 2;
    widthMultiplier = 0.9; // Используем полную ширину
    yOffsetDivider = 2.2;
    xOffsetMultiplier = 0.25; // Для безкаркасного режима центрируем по-другому
  } else {
    standardWindowWidthM = GRID_CELL_SIZE_M;
    widthMultiplier = 2.04;
    yOffsetDivider = 2.2;
    xOffsetMultiplier = 0.26; // Для модульного режима стандартное центрирование
  }

  const windowElementWidthPx = standardWindowWidthM * scale;
  const wallThicknessPx = wallThickness * scale;
  const svgRenderHeightPx = wallThicknessPx; // Высота SVG окна равна толщине стены
  const finalWindowWidthPx = windowElementWidthPx * widthMultiplier;

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.25)" :
      highlightForBlindsPlacement ? "rgba(40, 167, 69, 0.3)" : "rgba(173, 216, 230, 0.6)",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR :
      highlightForBlindsPlacement ? "#28a745" : "rgba(80, 80, 80, 0.8)",
    strokeWidth: isSelected ? 1.5 / (scale / 50) :
      highlightForBlindsPlacement ? 2 / (scale / 50) : 1 / (scale / 50),
    transition: "fill 0.15s ease-in-out, stroke 0.15s ease-in-out",
    filter: highlightForBlindsPlacement ? "drop-shadow(0 0 6px rgba(40, 167, 69, 0.6))" : "none",
  };

  // innerGroupTransform отвечает за отражение окна
  const innerGroupTransform = windowVisualNeedsFlip ? `scale(1, -1)` : "";

  return (
    // Группа для применения отражения (innerGroupTransform)
    // SVG окна позиционируется так, чтобы его центр был в (0,0) этой группы
    <g transform={innerGroupTransform}>
      <WindowSvg
        x={-finalWindowWidthPx * xOffsetMultiplier} // Центрируем SVG по горизонтали (разное для разных режимов)
        y={-svgRenderHeightPx / yOffsetDivider}    // Центрируем SVG по вертикали (по толщине стены)
        width={finalWindowWidthPx}
        height={svgRenderHeightPx}
        preserveAspectRatio="none"
        style={svgStyle}
        data-segment-id={segmentId}
        data-parent-wall-id={parentWallId}
        data-window-id={element?.id}
      />
    </g>
  );
};

export default React.memo(PanoramicWindowRenderer);